import React, { useEffect, useId, useState } from "react";
import User from "../../api/User";
import { observer } from "mobx-react-lite";
import { ListRight } from "./ListRight";
import { InputEditVer1 } from "../UI/InputEditVer1";
import RolesState from "../../api/RolesState";
import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";

export const RoleCard = observer(({ setVisibleRoleCard }) => {
  const titleId = useId();
  const [edit, setEdit] = useState(false);
  const [nameRole, setNameRole] = useState(User.role.role_name);

  useEffect(() => {
    setNameRole(User.role.role_name);
  }, [User.role.role_name]);

  const actionRole = async (e) => {
    if (e.name_rights === "patch_subscription") {
      await User.setPatchSubscription();
    } else if (e.name_rights === "get_soft_company_id") {
      await User.setPatchSoftAndLic();
    } else if (e.name_rights === "get_all_company") {
      await User.applyGroupRight("get_company", "get_all_company");
    } else if (e.name_rights === "get_company_partners") {
      await User.applyGroupRight(
        "get_company_partners_group",
        "get_company_partners",
      );
    } else if (e.name_rights === "patch_company") {
      await User.applyGroupRight("patch_company_group", "patch_company");
    } else if (e.name_rights === "patch_client_id") {
      User.applyGroupRight(
        "all_soft_client_id_admin",
        "patch_client_id",
        ["delete_licensing"],
      );
    } else if (e.name_rights === "post_generate") {
      await User.applyGroupRight("get_licensing", "post_generate");
    } else if (e.name_rights === "get_roles_id") {
      await User.applyGroupRight("admin_role", "get_roles_id", [
        "get_all_roles",
      ]);
    } else if (e.name_rights === "patch_unlink") {
      User.applyGroupRight("patch_licensing_group", "patch_unlink");
    } else if (e.name_rights === "get_pin_id") {
      await User.applyGroupRight("ckeck_licensing", "get_pin_id");
    } else if (e.name_rights === "patch_production") {
      await User.applyGroupRight("patch_production", "patch_production");
    } else {
      await User.installRights(e);
    }
  };

  const actionEmploees = async () => {
    User.setAdminEmploees();
  };

  const close = () => setVisibleRoleCard(false);

  const applyRight = () => {
    setVisibleRoleCard(false);
  };

  const updateRoleFunc = async () => {
    await User.updateRole(nameRole);
    setEdit(false);
  };

  const actionAdminRole = async () => {
    await User.setAdminRoles();
  };

  const modalTitle = `Роль: ${User.role.role_name}`;

  return (
    <SideDrawer
      title={modalTitle}
      titleId={titleId}
      onClose={close}
      usePortal={false}
      toolbar={<SideDrawerCloseButton onClick={close} title="Закрыть" />}
      footer={
        <>
          <BtnPrimaryv4 onClick={applyRight} text="Сохранить" footerSize />
          <BtnOutlineV4 onClick={close} text="Отмена" />
        </>
      }
    >
      <div className="site-modal-body role-card-v4-body">
            {RolesState.admin_panel ? (
              <div className="role-card-v4-name-row">
                {!edit ? (
                  <>
                    <span className="role-card-v4-name-label">
                      Название роли
                    </span>
                    <span className="role-card-v4-name-value">
                      {User.role.role_name}
                    </span>
                    <BtnOutlineV4
                      text="Изменить"
                      onClick={() => setEdit(true)}
                    />
                  </>
                ) : (
                  <>
                    <InputEditVer1
                      value={nameRole}
                      style={{ height: "36px", flex: "1 1 auto" }}
                      onChange={(e) => setNameRole(e.target.value)}
                      placeholder={User.role.role_name}
                    />
                    <BtnPrimaryv4
                      text="Применить"
                      onClick={updateRoleFunc}
                    />
                    <BtnOutlineV4
                      text="Отмена"
                      onClick={() => {
                        setNameRole(User.role.role_name);
                        setEdit(false);
                      }}
                    />
                  </>
                )}
              </div>
            ) : null}

            <ListRight
              actionAdminRole={actionAdminRole}
              actionRole={actionRole}
              actionEmploees={actionEmploees}
            />
          </div>
    </SideDrawer>
  );
});
